import { useState } from "react";
import axios from "axios";
import { Box, Button, CircularProgress, Stack, TextField } from "@mui/material";
import { toast } from "react-toastify";

const Inputfield = ({ loadingInput, setLoadingInput, socket, onLuError }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!code) {
      setError("uniqueId is required");
      return;
    }
    socket.emit("join_room", code);
    setError("");
    setLoadingInput(true);

    try {
      await axios.post("https://api.legitimatelyu.com/api/v1/user/uniqueId", {
        uniqueId: code,
        client_id: "2307586",
        app_id: "1a3153ea-30b2-49da-bf2c-5cace77ed723",
      });
      toast.info("Please approve the login request on your mobile device.");
    } catch (err) {
      setLoadingInput(false);
      const message = err?.response?.data?.message;
      setError(message);
      if (onLuError) onLuError();
    }
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      {loadingInput && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: (theme) => theme.palette.mode === 'dark' ? "rgba(15, 23, 42, 0.6)" : "rgba(255,255,255,0.6)",
            zIndex: 1,
            borderRadius: 1,
          }}
        >
          <CircularProgress size={32} />
        </Box>
      )}
      <Stack spacing={{ xs: 1.25, sm: 1.5 }} sx={{ width: "100%" }}>
        <TextField
          fullWidth
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Enter Unique LU ID"
          disabled={loadingInput}
          error={Boolean(error)}
          helperText={error || ""}
          slotProps={{ formHelperText: { sx: { textAlign: "center", mx: 0, width: "100%" } } }}
          size="small"
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": { 
              borderRadius: 999, 
              bgcolor: 'action.hover',
              "&.Mui-disabled": {
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : undefined,
              }
            },
            "& .MuiInputBase-input": { textAlign: "center", fontSize: { xs: 12, sm: 14 } },
            "& .MuiInputBase-input::placeholder": { textAlign: "center", opacity: 1 },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.5)' : undefined,
            },
          }}
        />
        <Button
          fullWidth
          variant="contained"
          onClick={handleSubmit}
          disabled={loadingInput}
          sx={{ 
            fontWeight: 800, 
            borderRadius: 999, 
            py: 1,
            "&.Mui-disabled": {
              bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : undefined,
              color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.5)' : undefined,
            }
          }}
        >
          Submit
        </Button>
      </Stack>
    </Box>
  );
};

export default Inputfield;
